import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  resourceId: attr('string'),
  unitToken: attr('string'),
  resource: computed('resourceId', 'store', function () {
    return this.resourceId ? this.store.peekRecord('resource', this.resourceId) : null;
  }),
  unit: computed('store', 'unitToken', function () {
    return this.unitToken ? this.store.peekRecord('merchant-subunit-ed', this.unitToken) : null;
  })
}).reopenClass({
  _modelNameForMigration: 'resource-membership'
});